import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { isNullOrUndefined } from 'shared/utils/type.utils';

@Component({
  selector: 'gms-error-and-notice-panel',
  templateUrl: 'error-panel.component.html',
  styleUrls: ['error-panel.component.scss'],
})
export class ErrorPanelComponent implements OnInit {
  constructor() {}
  _mainMessage = "Looks like there's no data";
  _subMessage = 'There is currently nothing to be displayed.';
  _mainErrorMessage = 'Uh oh! Something went wrong...';
  _subErrorMessage =
    'We ran into some trouble trying to load this page. Please try loading it again.';

  @Input()
  set mainMessage(message: any) {
    if (!isNullOrUndefined(message)) {
      this._mainMessage = message;
    }
  }

  @Input()
  set subMessage(message: any) {
    if (!isNullOrUndefined(message)) {
      this._subMessage = message;
    }
  }
  @Input()
  iconClass = 'icon-drought';

  @Input()
  set mainErrorMessage(message: any) {
    if (!isNullOrUndefined(message)) {
      this._mainErrorMessage = message;
    }
  }
  @Input()
  set subErrorMessage(message: any) {
    if (!isNullOrUndefined(message)) {
      this._subErrorMessage = message;
    }
  }

  @Input()
  iconErrorClass = 'icon-dead';

  @Input()
  error = false;

  @Input()
  reloadButtonText = 'Reload';

  @Input()
  showReloadButton = false;

  @Output()
  readonly reload = new EventEmitter<any>();

  ngOnInit(): void {}
}
